export const LABELS = {
    analysisStart: 'Analysis start',
    firstUnitDelivered: '1st unit delivered',
    constructionPeriod: 'Construction',
    constructionStartDate: 'Construction start',
};

export const ROW_HEIGHT = 60;
